module.exports = __webpack_public_path__ + "static/media/building.fa36ff1f.svg";